import React from "react";
import { useForm } from "react-hook-form";
import { Input, Form } from "components";
import { Button, SimpleGrid, VStack } from "@chakra-ui/react";
import { useUser } from "context/user";
import { updateUser } from "api/webservice/users";
import { useToast } from "hooks";

interface Props {
  callback: () => void;
}

type FormData = {
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: number;
  dob: number;
};

export const ProfileForm: React.FC<Props> = ({ callback }: Props) => {
  const { handleSubmit, errors, register, formState } = useForm<FormData>();
  const { user, setUser } = useUser()!;
  const toast = useToast();

  const validateUsername = (value: string) => {
    if (!value) {
      return "Username is required";
    } else return true;
  };

  const validateFirst_name = (value: string) => {
    if (!value) {
      return "First name is required";
    } else return true;
  };

  const validateLast_name = (value: string) => {
    if (!value) {
      return "Last name is required";
    } else return true;
  };

  const validateEmail = (value: string) => {
    if (!value) {
      return "Email is required";
    } else return true;
  };

  const submitForm = async ({
    username,
    email,
    first_name,
    last_name
  }: FormData): Promise<any | null> => {
    await updateUser({
      id: user.id,
      username,
      email,
      first_name,
      last_name
    })
      .then(updatedUser => {
        setUser(updatedUser);
        callback();
      })
      .catch(error => {
        console.log(error.response);
        toast({
          title: "Error updating profile",
          description: error.response.data.response,
          status: "error"
        });
      });
  };

  return (
    <Form defaultValues={user} onSubmit={handleSubmit(submitForm)}>
      <VStack spacing={8}>
        <SimpleGrid columns={[1, 2]} minW={{ md: "800px" }} spacing={6}>
          <Input
            variant="outline"
            label="First Name"
            defaultValue={user.first_name}
            name="first_name"
            register={register({ validate: validateFirst_name })}
            required
            errorMessage={errors.first_name?.message}
          />

          <Input
            variant="outline"
            label="Last Name"
            defaultValue={user.last_name}
            name="last_name"
            register={register({ validate: validateLast_name })}
            required
            errorMessage={errors.last_name?.message}
          />

          <Input
            variant="outline"
            label="Username"
            defaultValue={user.username}
            name="username"
            register={register({ validate: validateUsername })}
            errorMessage={errors.username?.message}
            required
          />

          <Input
            variant="outline"
            label="Email"
            defaultValue={user.email}
            type="email"
            name="email"
            register={register({ validate: validateEmail })}
            errorMessage={errors.email?.message}
            required
          />
        </SimpleGrid>

        <Button
          disabled={formState.isSubmitting}
          type="submit"
          size="md"
          variant="blue"
        >
          Save Profile
        </Button>
      </VStack>
    </Form>
  );
};
